import React, { Component } from "react";

class ProjectListing extends Component {

    render() {
        const childLinks = this.props.children
        var items = []
        return (
            <div className="row">
                {React.Children.map(childLinks, (child, i) => {
                    items.push(child)
                    if (i % this.props.perColumn === 1){
                        var column = <div className="col-4 col-12-mobile">{items}</div>
                        items = []
                        return column
                    }
                })}
            </div>
        );
    }
}

export default ProjectListing;